(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Close mobile nav on outside click / escape.
  (function () {
    document.querySelectorAll('[data-mobile-nav]').forEach(function (nav) {
      document.addEventListener('click', function (e) {
        if (nav.open && !nav.contains(e.target)) nav.open = false;
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.open) nav.open = false;
      });
      nav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { nav.open = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
